<template>
  <div v-show="!isAgreementPage">
    <van-overlay :show="agreementVisible" :lock-scroll="false" >
      <div  v-if="agreement" class="van-dialog" >
        <div class="van-dialog__header">店员协议</div>
        <div class="van-dialog__content">
          <div class="margin-lr-sm" v-html="agreement.content" style="max-height: 50vh;overflow-y: scroll;"></div>
        </div>
        <div class="van-hairline--top van-dialog__footer">
          <van-button size="large" :disabled="remainTime>0" @click="onConfirm">
            <span  :style="{color: remainTime>0?'#8B8B8B':'#ee0a24'}">{{confirmButtonText}}</span>
          </van-button>
        </div>
      </div>
    </van-overlay>
    <certification v-if="verifyVisible" :force="true" @success="onVerifySuccess" />
    <HandwriteDialog ref="handwriteDialog" @success="onSignSuccess" />
    <van-count-down v-show="false" ref="countDown" :time="countDown" :auto-start="false" @change="onCountDownChange"/>
  </div>

</template>

<script>
import {confirmClerkAgreement, getLastClerkAgreement} from "@/api/163/clerk/agreement";
import {handlePromise} from "@/libs/util";
import Vue from 'vue';
import {CountDown, Button, Toast} from 'vant';
import Certification from "@/views/certification";
import HandwriteDialog from "@/components/HandwriteDialog";

Vue.use(CountDown).use(Button);
export default {
  name: "agreementConfirmDialog",
  components: {HandwriteDialog, Certification},
  data() {
    return {
      id: null,
      loading: false,
      agreement: null,
      hasConfirm: false,
      isVerify: false,
      countDown: 15 * 1000,
      remainTime: null,
      model: {
        agreementChangeLogId: null,
        signUrl: null
      },
      agreementVisible: false,
      verifyVisible: false,
      isAgreementPage: false,
      rules: {}
    }
  },
  watch:{
    '$route'(val){
      if(val.path === '/agreement'){
        this.isAgreementPage = true
      }else{
        this.isAgreementPage = false
      }
    }
  },
  computed: {
    confirmButtonText() {
      if (this.remainTime) {
        return `${this.remainTime}s后可确认`
      }
      return `确认`
   }
  },
  methods: {
    onSignSuccess(signUrl){
      this.model.signUrl = signUrl
      this.doConfirm()
    },
    onVerifySuccess(){
      this.isVerify = true
      this.onConfirm()
    },
    onCountDownChange(timeData) {
      this.remainTime = timeData.seconds
    },
    startCountDown() {
      this.$refs.countDown.start()
    },
    loadData() {
      handlePromise(getLastClerkAgreement(), (data) => {
        this.agreement = data.agreement
        this.hasConfirm = !!data.hasConfirm
        this.isVerify = !!data.isVerify
        this.model.agreementChangeLogId = data.agreementChangeLogId
        // 有协议并且没有签署完成
        if (this.agreement && !this.hasConfirm) {
          // 因人脸实名而中断流程的，无需再次等待时间
          // if(localStorage.getItem('hasReadAgreement') === '1'){
          //   localStorage.removeItem('hasReadAgreement')
          //   this.onConfirm()
          // }else{
            this.agreementVisible = true
            this.remainTime = this.countDown
            this.startCountDown()
          // }

        }
      }, ()=>{}, () => {
      })
    },
    onConfirm() {
      this.agreementVisible = false
      // localStorage.setItem('hasReadAgreement','1')
      if(['verify','handwrite'].includes(this.agreement.signMethod) && !this.isVerify){
        this.verifyVisible = true
      }else if(this.agreement.signMethod === 'handwrite' && this.isVerify){
        this.$refs.handwriteDialog.show()
      } else{
        this.doConfirm()
      }
    },
    doConfirm(){
      Toast.loading({
        mask: true,
        message: '请稍候'
      })
      handlePromise(confirmClerkAgreement(this.agreement.id,this.model.agreementChangeLogId,this.model.signUrl),()=>{
        this.visible = false
      },null,()=>{
        Toast.clear()
      })
    },
    onVisibleChange(val) {
      if (!val) {
        this.$emit('on-close')
      }
    },
    onOk() {

    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="less" scoped>
</style>
